// extracted by mini-css-extract-plugin
export default {"ModalControls":"ModalControls_ModalControls__F6vfY"};